import { getShopIdFromLocation } from 'util/appUtils';
import { createLegacyIndexingApi } from '../indexing/legacyIndexingApi';

const shopPath = shopId => `/system/shop/${encodeURIComponent(shopId)}`;
const scopeOptions = (scope) => {
  if (scope === undefined || scope === 'default') return null;
  if (scope !== 'visual') throw new TypeError('Unknown empty-query scope');
  return { qs: { scope } };
};

/** Cloud/web-service implementation of the shared empty-query editor port. */
export function createLegacyEmptyQueryApi({ client, shopId } = {}) {
  let resolvedClient = client || null;
  const getClient = () => {
    if (!resolvedClient) {
      // eslint-disable-next-line global-require
      resolvedClient = require('util/appUtils').wsClient;
    }
    return resolvedClient;
  };
  const getShopId = () => shopId || getShopIdFromLocation();

  return {
    getSettings(scope = 'default') {
      const options = scopeOptions(scope);
      const args = ['GET', `${shopPath(getShopId())}/merchandising/empty-query`];
      if (options) args.push(options);
      return getClient().prepareRequest(...args);
    },

    saveSettings(settings, scope = 'default') {
      const options = scopeOptions(scope);
      return getClient().prepareRequest(
        'PUT',
        `${shopPath(getShopId())}/merchandising/empty-query`,
        { body: settings, ...(options || {}) },
      );
    },

    async getArtifact(scope = 'default') {
      const options = scopeOptions(scope);
      const args = ['GET', `${shopPath(getShopId())}/merchandising/empty-query/artifact`];
      if (options) args.push(options);
      const artifact = await getClient().prepareRequest(...args);
      return { ...artifact, product_preview: artifact?.product_preview || [] };
    },

    startReindex() {
      return createLegacyIndexingApi({ client: getClient() }).startFull(getShopId());
    },

    async searchCategories(query, limit = 8) {
      const response = await getClient().prepareRequest(
        'GET',
        `${shopPath(getShopId())}/catalog/categories/search`,
        { qs: { q: query, limit } },
      );
      return response?.items || [];
    },

    async resolveCategories(ids) {
      const response = await getClient().prepareRequest(
        'POST',
        `${shopPath(getShopId())}/catalog/categories/resolve`,
        { body: { ids } },
      );
      return response?.items || [];
    },
  };
}
